import React, { useState, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import { datePickerConstants } from "../../pages/interviewListingConstants";
import "react-day-picker/dist/style.css";
import { Button } from "reactstrap";
import { format } from "date-fns";

// Extract "This Week" from the date picker constants
const thisWeek = datePickerConstants.find(
  (dateRange) => Object.keys(dateRange)[0] === "This Week"
);

function InterviewDatePicker({
  setOpenDatePicker,
  onDateRange,
  selectedDatesMain,
  setSelectedDatesMain,
}) {
  const [selectedDates, setSelectedDates] = useState({
    from: thisWeek["This Week"].from,
    to: thisWeek["This Week"].to,
  });
  const [selectedLabel, setSelectedLabel] = useState("This Week");

  useEffect(() => {
    if (selectedDatesMain?.from && selectedDatesMain?.to) {
      setSelectedDates({
        from: selectedDatesMain?.from,
        to: selectedDatesMain?.to,
      });
    }
  }, [selectedDatesMain]);

  const handleApplyDates = () => {
    setOpenDatePicker(false);
    const dateRangeData = {
      from: selectedDates?.from
        ? format(selectedDates.from, "yyyy-MM-dd")
        : null,
      to: selectedDates?.to ? format(selectedDates.to, "yyyy-MM-dd") : null,
    };
    onDateRange(dateRangeData.from, dateRangeData.to, selectedLabel);
    setSelectedDatesMain(dateRangeData);
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-column justify-content-between align-items-start w-100">
        <div className="d-flex flex-row align-items-start justify-content-around w-100">
          <div className="d-flex flex-column align-items-start gap-2 mt-4">
            {datePickerConstants.map((datePicker, index) => {
              const [key, value] = Object.entries(datePicker)[0];
              return (
                <div key={index} className="date-pre-selector">
                  <button
                    className="report-date-btn"
                    onClick={() => {
                      setSelectedDates({ to: value?.to, from: value?.from });
                      setSelectedLabel(key);
                    }}
                  >
                    {key}
                  </button>
                </div>
              );
            })}
          </div>
          <div className="report-date-vr"></div>
          <DayPicker
            mode="range"
            selected={selectedDates}
            onSelect={setSelectedDates}
          />
        </div>
        <div
          className="d-flex flex-column gap-2 w-100 pe-3"
          style={{ position: "absolute", bottom: "15px" }}
        >
          <div className="report-date-hr pt-1 w-100"></div>
          <div className="d-flex flex-row ps-4 w-100 justify-content-between align-items-center px-3">
            <span className="me-1 report-date-preview-inner">
              {selectedDates?.from || selectedDates?.to ? (
                `${
                  selectedDates?.from
                    ? new Date(selectedDates.from).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : ""
                } - ${
                  selectedDates?.to
                    ? new Date(selectedDates.to).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : ""
                }`
              ) : (
                <span className="form-text">
                  Please select valid dates to preview.
                </span>
              )}
            </span>
            <div className="d-flex flex-row gap-2">
              <Button
                className="report-date-clear"
                onClick={() => {
                  // setOpenDatePicker(false);
                  setSelectedDates(null);
                }}
              >
                Clear
              </Button>
              <Button className="report-date-done" onClick={handleApplyDates}>
                Done
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default InterviewDatePicker;
